<app-page-header header="{{language.contactusheader}}" backgroundPath="assets/images/lead/lead-contact.jpg">
</app-page-header>
<div *ngIf="!sentEmailComplete" class="container">
  <div class="row">
    <div class="col-12">
      <header class="heading-contact">
        <h2 class="topic-title">{{language.contactustitle1}}</h2>
      </header>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-12 col-lg-7">
      <div class="form--wrapper">
        <div class="form--item">
          <div class="title">{{language.contactusform1}}</div>
          <div class="input">
            <div class="input--container">
              <input #UserName (blur)="setUsername(UserName.value)" required type="text" name="UserName"
                class="form-control" />
              <div *ngIf="nameReq" class="error-message">{{language.contactusformerror1}}</div>
            </div>
          </div>
        </div>
        <div class="form--item">
          <div class="title">{{language.contactusform2}}</div>
          <div class="input">
            <div class="input--container">
              <input required type="tel" name="Tel" [(ngModel)]="Tel" class="form-control" [maxLength]="10" />
              <div *ngIf="telReq" class="error-message">{{language.contactusformerror2}}</div>
            </div>
          </div>
        </div>
        <div class="form--item">
          <div class="title">{{language.contactusform3}}</div>
          <div class="input">
            <div class="input--container">
              <input [textMask]="{mask: emailPattern}" placeholder="___@___.___" required type="text" name="Email"
                [(ngModel)]="Email" class="form-control" />
              <div *ngIf="emailReq" class="error-message">{{language.contactusformerror3}}</div>
              <div *ngIf="emailinvalidPattern" class="error-message">{{language.contactusformerror4}}</div>
            </div>
          </div>
        </div>
        <div class="form--item">
          <div class="title">{{language.contactusform4}}</div>
          <div class="input">
            <app-select [selectList]="selectList" (fundId)="getFundIdFromSelect($event)" required
              [enableSearch]="false">
            </app-select>
            <!-- <select class="select--button" name="TopPic" [(ngModel)]="TopPic">
              <option *ngFor="let item of selectList; index as i;" value="{{ item.value }}">{{ item.title }}</option>
            </select> -->
            <div *ngIf="topicReq" class="error-message">{{language.contactusformerror5}}</div>
          </div>
        </div>
        <div class="form--item">
          <div class="title -top">{{language.contactusform5}}</div>
          <div class="input">
            <div class="input--container">
              <textarea #Detail (blur)="setDetail(Detail.value)" required name="Detail"></textarea>
              <div *ngIf="detailReq" class="error-message">{{language.contactusformerror6}}</div>
            </div>
          </div>
        </div>
        <div class="button--item">
          <div class="blank"></div>
          <div class="button--wrapper">
            <app-button (click)="sentMessage()" size="lg" text="{{language.contactusform10}}"></app-button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-5 col-md-12 col-lg-4 offset-lg-1">
      <div class="map-info">
        <div class="view">
          <div class="mapouter">
            <div class="gmap_canvas">
              <agm-map [latitude]="lat" [longitude]="lng" [scrollwheel]="false" [zoom]="17" [fullscreenControl]='true'
                [mapTypeControl]='true'>
                <agm-marker [latitude]="lat" [longitude]="lng" [iconUrl]="'../../../assets/images/icon/pin-one.png'">
                </agm-marker>
              </agm-map>
            </div>
          </div>

          <div class="info">
            <h5 class="topic-title">{{language.contactusaddress1}}</h5>
            <p>{{language.contactusaddress2}}
              <br class="d-none d-lg-block">
              {{language.contactusaddress3}}
              {{language.contactusaddress4}}
            </p>
          </div>
        </div>


        <div class="contact">
          <div class="contact--item">
            <span class="contact--icon">
              <img style="width: 15px; height: 29px;" src="assets/images/icon/icon-office@2x.png" alt="office" />
            </span>
            <span class="contact--title">{{language.contactusdetail1}}</span>
          </div>
          <div class="hr"></div>
          <div class="contact--item">
            <span class="contact--icon">
              <img src="assets/images/icon/ic-bts@2x.png" alt="bts" />
            </span>
            <span class="contact--title">{{language.contactusdetail2}}</span>
          </div>
          <div class="contact--item">
            <span class="contact--icon">
              <img src="assets/images/icon/icon-phone@2x.png" alt="office" />
            </span>
            <span class="contact--title">
              {{language.contactusdetail3}}<br>
              {{language.contactusdetail4}}
            </span>
          </div>
          <div class="contact--item">
            <span class="contact--icon">
              <img src="assets/images/icon/ic-fax@2x.png" alt="office" />
            </span>
            <span class="contact--title">{{language.contactusdetail5}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<section *ngIf="sentEmailComplete" id="empty-wrapper" class="section section--empty">
  <div class="container">
    <div class="wrapper">
      <header>
        <span class="icon" rel="border-circle">
          <i class="icon icon-email"></i>
        </span>
        <h1 class="title">{{language.contactusreply1}}</h1>
      </header>
      <p>{{language.contactusreply2}}
        <br>
        {{language.contactusreply3}}
      </p>
      <footer>
        <a [routerLink]="routerLinkVariable" class="btn btn-primary -brand">{{language.contactusreply4}}</a>
      </footer>
    </div>
  </div>
</section>

<ngx-ui-loader></ngx-ui-loader>

<!-- <div id="covidModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header -nobg">
        <div class="float-left">
          <h4 class="modal-title"><span class="text">แจ้งเตือน</span></h4>
        </div>
      </div>
      <section class="wrapper-notice">
        <div class="modal-body">
          <br>
          <p style="text-align: center;">เนื่องจากสถานการณ์โควิด-19</p><br>
          <p style="text-align: center;">บริษัทฯ ของดรับลูกค้า Walk-in สอบถามเพิ่มเติมได้ที่ 02-659-8888 กด 1</p>
          <br>
        </div>
      </section>

      <div class="modal-footer" style="margin: 0 auto">
        <app-button text="ปิด" size="lg" (click)="closeCovidModal()"></app-button>
      </div>

    </div>
  </div>
</div> -->